// extracted by mini-css-extract-plugin
export default {"root":"ConfirmTooltip_root__oEga7","row":"ConfirmTooltip_row__7yB10"};